import React from "react";

export default function DoneCircle({ id, style }) {
    return <svg id={id} width="100" height="100" viewBox="0 0 70 71" fill="none" xmlns="http://www.w3.org/2000/svg" style={{stroke: '#00B884', ...style}}>
    <path d="M47.0312 28.9375L30.9805 44.25L22.9688 36.5938" stroke-width="4.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M35 61.75C49.4975 61.75 61.25 49.9975 61.25 35.5C61.25 21.0025 49.4975 9.25 35 9.25C20.5025 9.25 8.75 21.0025 8.75 35.5C8.75 49.9975 20.5025 61.75 35 61.75Z" stroke-width="4.2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>;
}


// WEBPACK FOOTER //
// ./src/rifa/components/layout/icons/doneCircle.jsx